
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24c1.375 0 2.5-1.108 2.5-2.462h-5C9.5 22.892 10.625 24 12 24zm7.5-7.385v-6.153c0-3.779-2.038-6.942-5.625-7.779v-.837C13.875.825 13.037 0 12 0s-1.875.825-1.875 1.846v.837C6.55 3.52 4.5 6.671 4.5 10.461v6.154L2 19.077v1.23h20v-1.23l-2.5-2.462zM17 17.846H7v-7.385c0-3.052 1.887-5.538 5-5.538s5 2.486 5 5.538v7.385z","fill":"currentColor"}})])
          )
        }
      }
    